import type { TaskType } from '@mybusinessmate/schema';

/**
 * What a lead looks over before approving (Figma A05.6 "QA checklist"). Advisory: it never blocks an approval, and
 * the ticks are not kept (there is no table for them yet), so it is a prompt for the person reviewing, not a record.
 * TODO(api): only the Instagram post list is in the design; the others follow its pattern.
 */
export const QA_CHECKLIST: Record<TaskType, string[]> = {
  post: [
    'Matches the brief: format, copy and offer',
    'Brand colours, logo and fonts are right',
    'Prices and dates double-checked',
    'Spelling and hashtags',
    'Nothing important cut off in the 4:5 crop',
  ],
  reel: [
    'Matches the brief: hook, script and length',
    'Brand colours, logo and fonts are right',
    'Prices and dates double-checked',
    'Audio and captions are right',
    'Spelling and hashtags',
  ],
  website: [
    'Matches the brief: pages and sections',
    'Works on mobile and desktop',
    'Brand colours, logo and fonts are right',
    'Links, forms and buttons work',
    'Spelling, prices and opening hours',
  ],
  monthly_update: [
    'Matches what was asked',
    'Nothing else on the page moved',
    'Works on mobile and desktop',
    'Spelling and prices',
  ],
  custom: ['Matches what was asked', 'Files open and are named clearly', 'Spelling and details double-checked'],
};
